// eslint-disable-next-line @change/sibling-module-imports
import type { PartialPetition } from '../../api/petition';

export function isCommentsEnabled(petition: PartialPetition): boolean {
	return !petition.shouldHideUserActions;
}
